<mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
  @for (addr of displayedSuggestions$ | async; track addr) {
    <mat-option [value]="addr">
      {{ addr }}
    </mat-option>
  }
</mat-autocomplete>
<mat-chip-grid #chipList>
  @for (addr of values$ | async; track addr; let i = $index) {
    <mat-chip (removed)="remove(i)">
      {{ addr }}
      <button matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip>
  }
  <input
    #chipsInput
    matInput
    type="email"
    (blur)="onBlur($event)"
    (input)="onTextInput($event)"
    [matAutocomplete]="auto"
    [matChipInputFor]="chipList"
    [matChipInputSeparatorKeyCodes]="confirmKeys"
    (matChipInputTokenEnd)="add($event)"
  />
</mat-chip-grid>
